/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { MCPSetupCommandResponse, MCPTokenRequest, MCPTokenResponse } from '../models/index';
import {
  MCPSetupCommandResponseFromJSON,
  MCPSetupCommandResponseToJSON,
  MCPTokenRequestFromJSON,
  MCPTokenRequestToJSON,
  MCPTokenResponseFromJSON,
  MCPTokenResponseToJSON,
} from '../models/index';

export interface ApiJwtTokenMcpCreateRequest {
  mCPTokenRequest?: MCPTokenRequest;
}

/**
 *
 */
export class AuthenticationApi extends runtime.BaseAPI {
  /**
   * Mints a JWT bound to the current user, intended to be used as a bearer token against the MCP server at `/mcp`. The token includes a `scope: mcp` claim so MCP-only enforcement is possible at the edge.
   * Issue a long-lived MCP token
   */
  async apiJwtTokenMcpCreateRaw(
    requestParameters: ApiJwtTokenMcpCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MCPTokenResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api-jwt-token/mcp/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: MCPTokenRequestToJSON(requestParameters['mCPTokenRequest']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => MCPTokenResponseFromJSON(jsonValue));
  }

  /**
   * Mints a JWT bound to the current user, intended to be used as a bearer token against the MCP server at `/mcp`. The token includes a `scope: mcp` claim so MCP-only enforcement is possible at the edge.
   * Issue a long-lived MCP token
   */
  async apiJwtTokenMcpCreate(
    requestParameters: ApiJwtTokenMcpCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MCPTokenResponse> {
    const response = await this.apiJwtTokenMcpCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Returns a shell one-liner (``command``) and a PowerShell one-liner (``command_windows``) that download and run the MCP setup script with the correct ``--base-url``/``-BaseUrl`` and ``--username``/``-Username`` already filled in. Paste the relevant one into a terminal and enter your password when prompted.
   * Get MCP setup command
   */
  async apiMcpInstallRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MCPSetupCommandResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/mcp/install/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => MCPSetupCommandResponseFromJSON(jsonValue));
  }

  /**
   * Returns a shell one-liner (``command``) and a PowerShell one-liner (``command_windows``) that download and run the MCP setup script with the correct ``--base-url``/``-BaseUrl`` and ``--username``/``-Username`` already filled in. Paste the relevant one into a terminal and enter your password when prompted.
   * Get MCP setup command
   */
  async apiMcpInstallRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MCPSetupCommandResponse> {
    const response = await this.apiMcpInstallRetrieveRaw(initOverrides);
    return await response.value();
  }
}
